import * as React from 'react';
import './ReportHeader.scss';
import { Label } from 'reactstrap';
import { Report } from '../../../models';
import { useTranslations } from '../../../store/translations/hooks';
import { TK } from '../../../store/translations/translationKeys';

export interface ReportHeaderProps {
    companyLogo?: string
    template: { name: string; hideHeader?: boolean },
    report: Report,
}

const ReportHeader: React.FC<ReportHeaderProps> = ({companyLogo, template, report}) => {
    const t = useTranslations();
    
    return (
        <div className='reportHeaderContainer'>
            <img className='reportHeaderImage' src={companyLogo}/>
            <div className='reportHeaderFieldsContainer'>
                {template.hideHeader ? undefined : <div className='reportHeaderFields'>
                    <Label><h3>{template.name}</h3></Label>
                    <Label><b>{t(TK.client)}:</b> {report?.clientName}</Label>
                    {report?.professionalName ? <Label><b>{t(TK.professional)}:</b> {report?.professionalName}</Label> : undefined}
                    <Label><b>{t(TK.date)}:</b> {report?.creationDate?.substring(0, 10)}</Label>
                    {report?.lastChangeBy && report.lastChangeDt && <>
                        <Label size='sm'>({t(TK.editedAt)} {report.lastChangeDt.substring(0, 10)})</Label>
                    </>}
                </div>}
            </div>
        </div>
    );
}

export default ReportHeader;
